(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["shto-pdp-accordions"] && !Shopify.designMode) return;
  try {
    /* Accordions: one open at a time (native <details name> does it where supported; this covers the rest).
     Reviews: Judge.me's own widget fills [data-shto-jdgm]. Our button presses Judge.me's own
     "Write a review", so every function stays Judge.me's. Its rating summary also updates the buy box's stars. */
  (function () {
    function headerOffset() {
      var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
      if (!v) {
        var h = document.querySelector('[data-header-height]');
        v = h ? h.getBoundingClientRect().height : 0;
      }
      return (v || 0) + 16;
    }

    function scrollToEl(el) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = el.getBoundingClientRect().top + window.scrollY - headerOffset();
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    }

    /* Judge.me binds its clicks on the document, so a real bubbling click event, not el.click(). */
    function press(el) {
      if (el) el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    }

    function tagReviews(widget) {
      /* The check measures the first review by Figma's layer names. Judge.me re-renders, so this runs on every change. */
      var first = widget.querySelector('.jdgm-rev');
      if (!first) return;
      var map = {
        'accordions.review-wrap-1': first,
        'accordions.review-1.name': first.querySelector('.jdgm-rev__author'),
        'accordions.review-1.stars': first.querySelector('.jdgm-rev__rating'),
        'accordions.review-1.text': first.querySelector('.jdgm-rev__body'),
        'accordions.review-1.date': first.querySelector('.jdgm-rev__timestamp')
      };
      Object.keys(map).forEach(function (k) {
        var el = map[k];
        if (el && el.getAttribute('data-shto') !== k) el.setAttribute('data-shto', k);
      });
    }

    /* Judge.me's own "Write a review" button in its Review widget app block (the 2025 widget). */
    var JDGM_WRITE = '[data-testid="write-review-button"]';

    function syncButtons(root, widget) {
      var write = root.querySelector('[data-shto-reviews-write]');
      var jm = widget.querySelector('.jm-review-widget');
      if (!jm) return;
      if (write) {
        var canWrite = !!widget.querySelector(JDGM_WRITE);
        if (write.hidden === canWrite) write.hidden = !canWrite;
      }
    }

    /* The buy box's stars come from Shopify's review metafields when the page loads. Judge.me's own numbers win once
       its widget is in, so the two always agree; no reviews hides the rating. */
    function syncBuyRating(widget) {
      var jm = widget.querySelector('.jdgm-rev-widg');
      var btn = document.querySelector('[data-shto-buy-reviews]');
      if (!jm || !btn) return;
      var count = parseInt(jm.getAttribute('data-number-of-reviews'), 10) || 0;
      var rating = parseFloat(jm.getAttribute('data-average-rating')) || 0;
      var shown = (Math.round(rating * 10) / 10).toFixed(1);
      if (btn.dataset.shtoJdgmSync === count + '/' + rating) return;
      btn.dataset.shtoJdgmSync = count + '/' + rating;
      btn.hidden = count === 0;
      if (!count) return;
      btn.querySelectorAll('.shto-pdp-buy__star-fill').forEach(function (fill, i) {
        fill.style.width = Math.round(Math.max(0, Math.min(1, rating - i)) * 1000) / 10 + '%';
      });
      var text = btn.querySelector('.shto-pdp-buy__rating-text');
      if (text) text.textContent = shown + ' (' + count + ')';
      var label = btn.getAttribute('data-label-template');
      if (label) btn.setAttribute('aria-label', label.replace('[rating]', shown).replace('[count]', count));
    }

    function init(root) {
      if (root.dataset.shtoReady) return;
      root.dataset.shtoReady = '1';
      var items = Array.prototype.slice.call(root.querySelectorAll('.shto-pdp-accordions__item'));
      var reviews = root.querySelector('[data-shto-reviews]');
      var widget = root.querySelector('[data-shto-jdgm]');

      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d && o.open) o.open = false; });
        });
      });

      document.addEventListener('shto:open-reviews', function () {
        if (!reviews) return;
        /* Collapse the others instantly so the reviews don't move while the page scrolls to them. */
        root.classList.add('is-instant');
        items.forEach(function (o) { if (o !== reviews) o.open = false; });
        reviews.open = true;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            root.classList.remove('is-instant');
            scrollToEl(reviews);
            var head = reviews.querySelector('summary');
            if (head) head.focus({ preventScroll: true });
          });
        });
      });

      if (!widget) return;
      var write = root.querySelector('[data-shto-reviews-write]');
      /* Judge.me's page numbers (shown, centred under the reviews). Changing page must not move anything:
         - Judge.me scrolls the page to its widget after each page. Its own hook (jdgmSettings.scrollTo returning false)
           turns that off, for this widget only.
         - It empties the list while the next page loads, which the open accordion animated as closing and reopening.
           So the reviews box keeps its height and the accordion doesn't animate until the new reviews are in (or 4s). */
      var box = widget.closest('.shto-pdp-accordions__reviews') || widget;
      var noScroll = function () {
        var s = window.jdgmSettings;
        if (!s || s.shtoNoScroll) return;
        var original = s.scrollTo;
        s.scrollTo = function (target) {
          var el = target && target[0];
          if (el && el.closest && el.closest('[data-shto-jdgm]')) return false;
          return typeof original === 'function' ? original.apply(this, arguments) : true;
        };
        s.shtoNoScroll = true;
      };
      noScroll();
      widget.addEventListener('click', function (e) {
        if (!e.target.closest('.jdgm-paginate__page:not(.jdgm-curt)')) return;
        noScroll();
        var oldFirst = widget.querySelector('.jdgm-rev');
        box.style.minHeight = box.offsetHeight + 'px';
        root.classList.add('is-instant');
        var done = false, timer, watch;
        var release = function () {
          if (done) return;
          done = true;
          clearTimeout(timer);
          if (watch) watch.disconnect();
          box.style.minHeight = '';
          setTimeout(function () { root.classList.remove('is-instant'); }, 50);
        };
        watch = new MutationObserver(function () {
          var first = widget.querySelector('.jdgm-rev');
          if (first && first !== oldFirst) setTimeout(release, 150);
        });
        watch.observe(widget, { childList: true, subtree: true });
        timer = setTimeout(release, 4000);
      }, true);
      /* Judge.me's write a review form opens as its own pop-up over the page. */
      if (write) write.addEventListener('click', function () {
        press(widget.querySelector(JDGM_WRITE));
      });
      var queued = false;
      function update() {
        queued = false;
        tagReviews(widget);
        syncButtons(root, widget);
        syncBuyRating(widget);
      }
      update();
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(update);
      }).observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'data-number-of-reviews'] });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-shto-accordions]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shto-pdp-buy"] && !Shopify.designMode) return;
  try {
    /* Shto buy box: variant choice, price/sale/sold-out state, add to bag, Postscript notify-me, sticky bar. */
  (function () {
    function money(cents, format) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      function group(n, sep) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
      return (format || '$[amount]').replace(/\{\{\s*(\w+)\s*\}\}|\[(amount)\]/, function (m, k1, k2) {
        var kind = k1 || k2;
        if (kind === 'amount_no_decimals') return group(String(Math.round(cents / 100)), ',');
        if (kind === 'amount_with_comma_separator') return group(parts[0], '.') + ',' + parts[1];
        if (kind === 'amount_no_decimals_with_comma_separator') return group(String(Math.round(cents / 100)), '.');
        if (kind === 'amount_with_apostrophe_separator') return group(parts[0], "'") + '.' + parts[1];
        return group(parts[0], ',') + '.' + parts[1];
      });
    }
    function fire(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true })); }
    function dateText(days) {
      var d = new Date(); d.setDate(d.getDate() + days);
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }

    function init(root) {
      if (root.__shtoBuy) return; root.__shtoBuy = true;
      var section = root.closest('.shto-pdp') || document;
      var dataEl = section.querySelector('[data-shto-product]');
      var cfgEl = root.querySelector('[data-shto-buy-config]');
      if (!dataEl || !cfgEl) return;
      var product = JSON.parse(dataEl.textContent);
      var cfg = JSON.parse(cfgEl.textContent);
      var names = {};
      String(cfg.sizeNames || '').split(',').forEach(function (pair) {
        var kv = pair.split(':'); if (kv.length > 1) names[kv[0].trim()] = kv.slice(1).join(':').trim();
      });
      var form = root.querySelector('[data-shto-buy-form]');
      var errorEl = root.querySelector('[data-shto-buy-error]');
      var sticky = root.querySelector('[data-shto-buy-sticky]');
      // The sticky bar lives in <body>: the right column is position: sticky, which would keep any z-index of ours
      // under the page below it (the footer). It keeps the .shto tokens through its wrapper.
      var portal = null;
      if (sticky) {
        var key = 'shto-buy-portal-' + (root.id || 'main');
        var old = document.getElementById(key); if (old) old.remove();
        portal = document.createElement('div');
        portal.id = key; portal.className = 'shto shto-pdp-buy-portal';
        portal.appendChild(sticky); document.body.appendChild(portal);
      }
      var scopes = portal ? [root, portal] : [root];
      function all(sel) { var out = []; scopes.forEach(function (sc) { sc.querySelectorAll(sel).forEach(function (el) { out.push(el); }); }); return out; }
      var idInputs = all('[data-shto-buy-id]');
      var qtyInputs = all('[data-shto-buy-qty]');
      var stickySize = portal && portal.querySelector('[data-shto-buy-sticky-size]');
      var params = new URLSearchParams(location.search);
      var startId = Number(params.get('variant')) || Number(idInputs[0] && idInputs[0].value);
      var variant = product.variants.find(function (v) { return v.id === startId; }) || product.variants.find(function (v) { return v.available; }) || product.variants[0];
      var options = variant.options.slice();

      function match(opts) {
        return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      }
      function each(sel, fn) { all(sel).forEach(fn); }

      function paint() {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        var soldOut = !variant.available;
        scopes.forEach(function (sc) { sc.classList.toggle('is-sold-out', soldOut); sc.classList.toggle('is-on-sale', !!onSale); });
        each('[data-shto-buy-price]', function (el) { el.textContent = money(variant.price, cfg.moneyFormat); });
        each('[data-shto-buy-compare]', function (el) { el.hidden = !onSale; if (onSale) el.textContent = money(variant.compare_at_price, cfg.moneyFormat); });
        each('[data-shto-buy-add-prices]', function (el) { el.hidden = !onSale; });
        each('[data-shto-buy-sale-line]', function (el) { el.hidden = !onSale; });
        each('[data-shto-buy-badge]', function (el) {
          el.hidden = !onSale;
          if (onSale) el.firstElementChild.textContent = String(cfg.badge || '').replace('[percent]', Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price));
        });
        idInputs.forEach(function (el) { el.value = variant.id; });
        // Shop Pay Installments: tell Shopify's message the new variant (it reads the attribute and its form's id input).
        each('[data-shto-buy-terms]', function (f) {
          var t = f.querySelector('shopify-payment-terms'), input = f.querySelector('[name="id"]');
          if (t && t.getAttribute('variant-id') !== String(variant.id)) { t.setAttribute('variant-id', variant.id); if (input) input.dispatchEvent(new Event('change', { bubbles: true })); }
        });
        // Option boxes: the chosen value, and which values are sold out with the other options as chosen.
        each('[data-shto-buy-option]', function (set) {
          var oi = Number(set.getAttribute('data-shto-buy-option'));
          var value = options[oi];
          var label = set.querySelector('[data-shto-buy-option-label]');
          if (label) label.textContent = (oi === cfg.sizeIndex && names[value]) || value;
          set.querySelectorAll('[data-shto-buy-value]').forEach(function (input) {
            input.checked = input.value === value;
            var opts = options.slice(); opts[oi] = input.value;
            var v = match(opts);
            var sold = !v || !v.available;
            var box = input.nextElementSibling;
            box.classList.toggle('is-sold', sold);
            var txt = box.querySelector('[data-shto-buy-sold-text]'); if (txt) txt.textContent = sold ? root.getAttribute('data-sold-text') || '' : '';
          });
        });
        // Low stock: "Last one left" / "Only 2 left" under the sizes, for the chosen size only.
        var low = (cfg.lowStock || {})[variant.id] || 0;
        each('[data-shto-buy-low]', function (el) { el.hidden = !low; if (low) el.textContent = low === 1 ? String(cfg.lowTextOne || '') : String(cfg.lowText || '').replace('[count]', low); });
        if (stickySize && cfg.sizeIndex > -1) stickySize.value = options[cfg.sizeIndex];
        each('[data-shto-buy-add], [data-shto-buy-sticky-add]', function (el) { el.hidden = soldOut; if (el.type === 'submit') el.disabled = soldOut; });
        each('[data-shto-buy-notify], [data-shto-buy-sticky-notify]', function (el) { el.hidden = !soldOut; });
        each('[data-shto-buy-express]', function (el) { el.inert = soldOut; });
        qtyInputs.forEach(function (el) { el.disabled = soldOut; });
        stepState();
        var img = portal && portal.querySelector('[data-shto-buy-sticky-img]');
        if (img && variant.featured_image && variant.featured_image.src) {
          var src = variant.featured_image.src.replace(/^https?:/, '');
          var url = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=180';
          if (img.getAttribute('src') !== url) { img.src = url; img.removeAttribute('srcset'); }
        }
        if (errorEl) errorEl.hidden = true;
      }
      function stepState() {
        var soldOut = !variant.available;
        var q = Number(qtyInputs[0] && qtyInputs[0].value) || 1;
        each('[data-shto-buy-step="-1"]', function (b) { b.disabled = soldOut || q <= 1; });
        each('[data-shto-buy-step="1"]', function (b) { b.disabled = soldOut; });
      }
      function setQty(n) {
        n = Math.max(1, Math.floor(Number(n) || 1));
        qtyInputs.forEach(function (el) { el.value = n; el.style.setProperty('--shto-digits', String(n).length); });
        stepState();
      }
      function select(opts, silent) {
        var v = match(opts);
        if (!v) {
          // That combination doesn't exist: keep the value just picked and take the first variant that has it.
          var changed = opts.findIndex(function (o, i) { return o !== options[i]; });
          var pool = product.variants.filter(function (x) { return changed < 0 || x.options[changed] === opts[changed]; });
          v = pool.find(function (x) { return x.available; }) || pool[0] || variant;
        }
        var same = v.id === variant.id;
        variant = v; options = v.options.slice();
        paint();
        if (!same && !silent) {
          // Same as the theme: the chosen variant goes in the address, so a shared link opens on it (Postscript reads it too).
          var url = new URL(location.href); url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url.toString());
          fire('shto:variant-change', { variant: v });
        }
      }
      function selectValue(oi, value) { var opts = options.slice(); opts[oi] = value; select(opts); }

      function on(type, fn) { scopes.forEach(function (sc) { sc.addEventListener(type, fn); }); }
      on('change', function (e) {
        var t = e.target;
        if (t.matches('[data-shto-buy-value]')) { selectValue(Number(t.closest('[data-shto-buy-option]').getAttribute('data-shto-buy-option')), t.value); }
        else if (t === stickySize) { selectValue(cfg.sizeIndex, t.value); }
        else if (t.matches('[data-shto-buy-qty]')) { setQty(t.value); }
      });
      on('input', function (e) {
        if (e.target.matches('[data-shto-buy-qty]')) e.target.style.setProperty('--shto-digits', Math.max(1, e.target.value.length));
      });
      on('click', function (e) {
        var t = e.target.closest('button'); if (!t) return;
        if (t.hasAttribute('data-shto-buy-step')) { setQty((Number(qtyInputs[0].value) || 1) + Number(t.getAttribute('data-shto-buy-step'))); }
        else if (t.hasAttribute('data-shto-buy-guide')) { fire('shto:size-guide', { tab: t.getAttribute('data-shto-buy-guide') }); }
        else if (t.hasAttribute('data-shto-buy-reviews')) { fire('shto:open-reviews', {}); }
        // Phones (client revision 2026-10-04): the sticky bar is one button that takes the shopper back up to the buy box:
        // the end of the buy box (estimated delivery) just above the bottom of the screen, never so far that the title
        // goes under the header.
        else if ((t.hasAttribute('data-shto-buy-sticky-add') || t.hasAttribute('data-shto-buy-sticky-notify')) && window.matchMedia('(max-width: 989.98px)').matches) {
          var end = root.querySelector('.shto-pdp-buy__delivery') || root.querySelector('.shto-pdp-buy__cta') || root;
          var title = root.querySelector('.shto-pdp-buy__title') || root;
          var header = document.querySelector('[data-header-height], .header__wrapper, #shopify-section-header, header');
          var headerH = header ? header.getBoundingClientRect().height : 0;
          var y = Math.min(end.getBoundingClientRect().bottom + window.scrollY - window.innerHeight + 24, title.getBoundingClientRect().top + window.scrollY - headerH - 12);
          window.scrollTo({ top: Math.max(0, y), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
        else if (t.hasAttribute('data-shto-buy-notify') || t.hasAttribute('data-shto-buy-sticky-notify')) { notify(); }
        else if (t.hasAttribute('data-shto-buy-sticky-add')) { var main = form.querySelector('[data-shto-buy-add]'); if (form.requestSubmit) form.requestSubmit(main); else main.click(); }
      });

      function add(quantity) {
        if (!variant.available || root.classList.contains('is-busy')) return Promise.resolve();
        root.classList.add('is-busy');
        each('[data-shto-buy-add], [data-shto-buy-sticky-add]', function (b) { b.setAttribute('aria-busy', 'true'); });
        return window.ShtoCart.add([{ id: variant.id, quantity: quantity || Number(qtyInputs[0] && qtyInputs[0].value) || 1 }]).catch(function (err) {
          if (errorEl) { errorEl.textContent = (err && err.message) || cfg.addError; errorEl.hidden = false; }
        }).finally(function () {
          root.classList.remove('is-busy');
          each('[data-shto-buy-add], [data-shto-buy-sticky-add]', function (b) { b.removeAttribute('aria-busy'); });
        });
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!window.ShtoCart) { form.submit(); return; }
        add();
      });

      // Postscript back-in-stock: open its sign-up popup for the chosen product and size (its SDK API), or click
      // its own trigger button if that's on the page.
      function notify() {
        var ps = window.postscript && window.postscript.backInStock;
        if (ps && ps.find && ps.open) {
          ps.find().then(function (id) {
            if (!id) return clickTrigger();
            ps.open(id, {
              product: { id: String(product.id), name: product.title },
              variant: { id: String(variant.id), name: variant.public_title || variant.title }
            });
          }, clickTrigger);
          return;
        }
        clickTrigger();
      }
      function clickTrigger() {
        var sel = '#ps-bis-widget__button, #ps__bis_container_root button, #ps__bis_container_root [role=button], #ps__bis_target_container button';
        var btn = document.querySelector(sel);
        if (btn) { btn.click(); return; }
        var waited = 0;
        var timer = setInterval(function () {
          waited += 200;
          var b = document.querySelector(sel);
          if (b || waited >= 6000) { clearInterval(timer); if (b) b.click(); }
        }, 200);
      }

      document.addEventListener('shto:select-size', function (e) {
        var d = e.detail || {};
        if (cfg.sizeIndex < 0 || d.value == null) return;
        selectValue(cfg.sizeIndex, String(d.value));
        if (d.add) {
          if (variant.available) add(); else root.querySelector('[data-shto="buy.row"]').scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });

      // Estimated delivery: today + N days, worked out in the shopper's own browser.
      each('[data-shto-buy-dates]', function (el) { el.textContent = dateText(Number(cfg.deliveryMin) || 0) + ' – ' + dateText(Number(cfg.deliveryMax) || 0); });

      // Sticky bar: shows once the size choice and ADD TO BAG have scrolled up out of view; hides when they come back.
      // It also waits until the end of the photos and reviews (the whole top of the page: side by side on desktop,
      // stacked on phones) has scrolled up above where the bar sits, so it never covers them.
      // Checked on scroll (at most once a frame) as well as by an observer: a jump straight past them (End key, a
      // restored scroll position) never crosses the screen, so an observer alone would miss it.
      // While the bar shows, <html> gets shto-buy-sticky-on and --shto-sticky-h (its height): the page keeps that much
      // room at the bottom so the footer's last line isn't hidden, and Postscript's "10% off" tab sits above the bar.
      if (sticky) {
        var watched = [root.querySelector('[data-shto-buy-option]'), root.querySelector('[data-shto-buy-watch]')].filter(Boolean);
        var grid = root.closest('.shto-pdp') && root.closest('.shto-pdp').querySelector('.shto-pdp__grid');
        var html = document.documentElement, shown = null, queued = false;
        var check = function () {
          queued = false;
          var show = watched.length > 0 && watched.every(function (el) { return el.getBoundingClientRect().bottom < 0; });
          if (show && grid) show = grid.getBoundingClientRect().bottom <= window.innerHeight - sticky.offsetHeight;
          if (show === shown) return;
          shown = show;
          sticky.classList.toggle('is-visible', show);
          sticky.inert = !show;
          html.classList.toggle('shto-buy-sticky-on', show);
          if (show) html.style.setProperty('--shto-sticky-h', sticky.offsetHeight + 'px');
        };
        // Postscript's small "UNLOCK 10% OFF" tab (iframe#ps__widget, fixed at the bottom-left, top z-index) would cover the
        // bar: while the bar shows and the iframe is that small tab (not its full-size popup), it moves up by the bar's height,
        // less PS_TUCK: the iframe's own bottom margin plus the bar's top padding left a ~49px gap above ADD TO CART;
        // tucking it 29px lower leaves ~20px (client revision 2026-10-07: 60% less space).
        var psSeen = null, PS_TUCK = 29;
        var lift = function () {
          var ps = document.getElementById('ps__widget');
          if (!ps) return;
          if (ps !== psSeen && 'ResizeObserver' in window) { psSeen = ps; new ResizeObserver(function () { lift(); }).observe(ps); }
          var r = ps.getBoundingClientRect();
          var small = r.height > 0 && r.height < 240 && r.width < window.innerWidth;
          ps.style.translate = shown && small ? '0 ' + (PS_TUCK - sticky.offsetHeight) + 'px' : '';
        };
        var check0 = check;
        check = function () { check0(); lift(); };
        var queue = function () { if (!queued) { queued = true; requestAnimationFrame(check); } };
        window.addEventListener('scroll', queue, { passive: true });
        window.addEventListener('resize', queue, { passive: true });
        if ('IntersectionObserver' in window) { var io = new IntersectionObserver(queue); watched.concat(grid ? [grid] : []).forEach(function (el) { io.observe(el); }); }
        queue();
      }

      paint();
      setTimeout(function () { fire('shto:variant-change', { variant: variant }); }, 0);
    }

    /* Shop Pay Installments message, reworded (client revision 2026-10-04): "4 payments at 0% interest with [Shop] (?)".
       The number of payments stays Shopify's (it depends on the price); if its wording changes and no number is found,
       Shopify's own message stays. Shopify draws it in an open shadow root and redraws it when the variant changes, so
       this runs again on every change. */
    function terms(el) {
      if (el.dataset.shtoTerms) return;
      el.dataset.shtoTerms = '1';
      var tries = 0;
      (function attach() {
        var sr = el.shadowRoot;
        if (!sr) { if (tries++ < 40) setTimeout(attach, 250); else delete el.dataset.shtoTerms; return; }
        var apply = function () {
          var content = sr.getElementById('shopify-installments-content');
          if (!content || content.querySelector('[data-shto-terms]')) return;
          var m = content.textContent.match(/(?:pay in\s+)?(\d+)\s+(?:interest-free\s+)?(?:installments|payments)/i);
          var logo = content.querySelector('svg');
          if (!m || !logo) return;
          var holder = logo.closest('div') || logo;
          var text = document.createElement('span');
          text.setAttribute('data-shto-terms', '');
          text.textContent = m[1] + ' payments at 0% interest with ';
          while (content.firstChild) content.removeChild(content.firstChild);
          content.append(text, holder);
        };
        /* The page's font, not Shopify's own (GT Standard), so it matches Sezzle's line; and Shopify's (?) icon becomes the
           same (i) character Sezzle uses, so both lines end the same way and are the same height. */
        var style = document.createElement('style');
        style.textContent = '#shopify-installments,#shopify-installments *{font-family:inherit!important}' +
          '#shopify-installments-cta{padding:0 0 0 6px!important;line-height:inherit;font:inherit!important;color:inherit}' +
          '#shopify-installments-cta svg{display:none!important}#shopify-installments-cta::after{content:"\\24D8"}';
        sr.appendChild(style);
        apply();
        new MutationObserver(apply).observe(sr, { childList: true, subtree: true });
      })();
    }

    function start(scope) {
      (scope || document).querySelectorAll('[data-shto-buy]').forEach(init);
      (scope || document).querySelectorAll('[data-shto-buy-terms] shopify-payment-terms').forEach(terms);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); }); else start();
    document.addEventListener('shopify:section:load', function (e) { start(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shto-pdp-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    var clickZoom = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    var desktop = window.matchMedia('(min-width: 990px)');

    function init(root) {
      if (root.shtoGallery) return;
      root.shtoGallery = true;
      var track = root.querySelector('[data-shto-gallery-track]');
      var slides = Array.prototype.slice.call(track.children);
      var expand = root.querySelector('[data-shto-gallery-expand]');
      var dialog = root.querySelector('[data-shto-gallery-dialog]');
      if (!dialog) return;
      var ztrack = dialog.querySelector('[data-shto-gallery-ztrack]');
      var thumbs = dialog.querySelector('[data-shto-gallery-thumbs]');
      var thumbButtons = Array.prototype.slice.call(thumbs.children);
      var bar = dialog.querySelector('[data-shto-gallery-bar]');

      /* Slider (phones) */
      function step(el) { var first = el.children[0]; return first ? first.offsetWidth : el.clientWidth; }
      function current() { return Math.round(track.scrollLeft / Math.max(step(track), 1)); }
      function go(el, index, smooth) {
        var n = el.children.length; if (!n) return;
        index = (index + n) % n;
        el.scrollTo({ left: Math.min(index * step(el), el.scrollWidth - el.clientWidth), behavior: smooth ? 'smooth' : 'auto' });
      }
      function perView() { return Math.max(1, Math.round(track.clientWidth / Math.max(step(track), 1))); }
      function move(dir) {
        var last = slides.length - perView(), i = current() + dir;
        var wrapTo = i > last ? 0 : i < 0 ? last : -1;
        if (wrapTo > -1 && window.ShtoSwipe && ShtoSwipe.jump) { ShtoSwipe.jump(track, Math.min(wrapTo * step(track), track.scrollWidth - track.clientWidth), dir); return; }
        if (i > last) i = 0; else if (i < 0) i = last;
        go(track, i, true);
      }
      var prev = root.querySelector('[data-shto-gallery-prev]');
      var next = root.querySelector('[data-shto-gallery-next]');
      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
      var lastIndex = 0;
      track.addEventListener('scroll', function () {
        var i = current();
        if (i !== lastIndex) { lastIndex = i; hint(false); }
      }, { passive: true });

      /* The expand button opens the zoom view straight away (no "Tap to expand" step). */
      function hint(on) {
        root.classList.toggle('shto-pdp-gallery--hint', on);
        if (expand) expand.setAttribute('aria-expanded', on ? 'true' : 'false');
      }
      if (expand) expand.addEventListener('click', function () { open(current()); });
      slides.forEach(function (slide, i) {
        slide.addEventListener('click', function (e) {
          if (clickZoom.matches && e.pointerType !== 'touch') { toggleZoom(slide, e); return; }
          open(desktop.matches ? i : current());
        });
      });

      /* Zoom view */
      function setActive(i) {
        thumbButtons.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        var t = thumbButtons[i];
        if (t) {
          var left = t.offsetLeft - (thumbs.clientWidth - t.offsetWidth) / 2;
          thumbs.scrollTo({ left: Math.max(0, Math.min(left, thumbs.scrollWidth - thumbs.clientWidth)), behavior: dialog.open ? 'smooth' : 'auto' });
        }
      }
      function zcurrent() { return Math.round(ztrack.scrollLeft / Math.max(step(ztrack), 1)); }
      function paintBar() {
        var max = thumbs.scrollWidth, view = thumbs.clientWidth, full = bar.parentNode.clientWidth;
        var w = max > 0 ? Math.min(1, view / max) : 1;
        bar.style.width = (w * 100) + '%';
        var room = full * (1 - w), ratio = max - view > 0 ? thumbs.scrollLeft / (max - view) : 0;
        bar.style.transform = 'translateX(' + (room * ratio) + 'px)';
      }
      var zi = 0;
      ztrack.addEventListener('scroll', function () {
        var i = zcurrent();
        if (i !== zi) { zi = i; setActive(i); }
      }, { passive: true });
      thumbs.addEventListener('scroll', paintBar, { passive: true });
      thumbButtons.forEach(function (b, i) { b.addEventListener('click', function () { go(ztrack, i, true); }); });
      function open(i) {
        hint(false);
        dialog.showModal();
        document.documentElement.classList.add('shto-lock');
        zi = i;
        go(ztrack, i, false);
        setActive(i);
        paintBar();
      }
      dialog.querySelector('[data-shto-gallery-close]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('close', function () {
        document.documentElement.classList.remove('shto-lock');
        if (!desktop.matches) go(track, zi, false);
      });
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { go(ztrack, Math.min(zcurrent() + 1, ztrack.children.length - 1), true); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { go(ztrack, Math.max(zcurrent() - 1, 0), true); e.preventDefault(); }
      });
      window.addEventListener('resize', function () { if (dialog.open) { go(ztrack, zi, false); paintBar(); } }, { passive: true });

      /* Desktop click zoom (Princess Polly style): the photo zooms 2.5x in place, centred on the cursor, and follows it.
         A 2000px copy fades in over the photo once loaded. Clicking again or leaving the photo zooms out. */
      function aim(slide, e) {
        var r = slide.getBoundingClientRect();
        slide.style.setProperty('--zx', Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100)) + '%');
        slide.style.setProperty('--zy', Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100)) + '%');
      }
      function zoomOut(slide) { slide.classList.remove('is-zoomed'); }
      function toggleZoom(slide, e) {
        if (slide.classList.contains('is-zoomed')) { zoomOut(slide); return; }
        slides.forEach(zoomOut);
        aim(slide, e);
        var hi = slide.querySelector('.shto-pdp-gallery__hi');
        if (!hi && slide.dataset.zoom) {
          hi = document.createElement('img');
          hi.className = 'shto-pdp-gallery__hi';
          hi.alt = ''; hi.decoding = 'async';
          hi.onload = function () { hi.classList.add('is-loaded'); };
          hi.src = slide.dataset.zoom;
          slide.querySelector('.shto-pdp-gallery__img').after(hi);
        }
        slide.classList.add('is-zoomed');
      }
      slides.forEach(function (slide) {
        slide.addEventListener('pointermove', function (e) { if (slide.classList.contains('is-zoomed')) aim(slide, e); });
        slide.addEventListener('pointerleave', function () { zoomOut(slide); });
      });

      /* A variant with its own photo shows that photo. */
      var first = true;
      document.addEventListener('shto:variant-change', function (e) {
        var v = e.detail && e.detail.variant, id = v && v.featured_media && v.featured_media.id;
        var initial = first; first = false;
        if (!id) return;
        var index = slides.findIndex(function (s) { return s.dataset.mediaId === String(id); });
        if (index < 0) return;
        if (!desktop.matches) go(track, index, !initial);
        else if (!initial) {
          var r = slides[index].getBoundingClientRect();
          if (r.top < 0 || r.bottom > window.innerHeight) slides[index].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    function initAll(scope) { (scope || document).querySelectorAll('[data-shto-gallery]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shto-pdp-size-guide"] && !Shopify.designMode) return;
  try {
    /* Size guide dialog. Opens on shto:size-guide { tab }, closes on the X, Escape or a click beside it (desktop).
     Custom dropdowns are listboxes: click or Enter/Space/Arrow keys open them, arrows move, Enter picks, Escape closes. */
  (function () {
    var IN_CM = 2.54, LB_KG = 2.20462;

    function norm(s) {
      s = String(s || '').toUpperCase().replace(/\s+/g, '');
      var m = s.match(/^(X+)L$/);
      if (m && m[1].length > 1) s = m[1].length + 'XL';
      return s;
    }
    function num(v) { v = String(v || '').replace(',', '.').trim(); return v === '' || isNaN(+v) ? null : +v; }
    function fmt(n, places) { return (Math.round(n * Math.pow(10, places)) / Math.pow(10, places)).toFixed(places); }
    function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

    function parseConversion(text) {
      var map = {};
      String(text || '').split(/\r?\n/).forEach(function (line) {
        var i = line.indexOf(':'); if (i < 1) return;
        var key = norm(line.slice(0, i)); map[key] = map[key] || {};
        line.slice(i + 1).split('|').forEach(function (part) {
          var bits = part.trim().split(/\s+/); if (bits.length < 2) return;
          map[key][bits.shift().toUpperCase()] = bits.join(' ');
        });
      });
      return map;
    }
    function parseBands(text) {
      var list = [];
      String(text || '').split(/\r?\n/).forEach(function (line) {
        var i = line.indexOf(':'); if (i < 1) return;
        var max = parseFloat(line.slice(i + 1)); if (isNaN(max)) return;
        list.push({ label: line.slice(0, i).trim(), key: norm(line.slice(0, i)), max: max });
      });
      return list;
    }

    function init(root) {
      if (root.__shtoSg) return; root.__shtoSg = true;
      var dialog = root.querySelector('[data-shto-sg-dialog]');
      if (!dialog) return;
      var cfg = {};
      try { cfg = JSON.parse(root.querySelector('[data-shto-sg-config]').textContent); } catch (e) {}
      var conversion = parseConversion(cfg.conversion);
      var bandsLetters = parseBands(cfg.bands);
      var waistBands = parseBands(cfg.waistBands);
      var guideBands = parseBands(cfg.guideBands); /* this product's size guide entry (its block / fit), when filled in */
      var countries = String(cfg.countries || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
      var scroller = dialog.querySelector('[data-shto-sg-scroll]');
      var tabs = [].slice.call(dialog.querySelectorAll('[data-shto-sg-tab]'));
      var panes = {}; [].forEach.call(dialog.querySelectorAll('[data-shto-sg-pane]'), function (p) { panes[p.getAttribute('data-shto-sg-pane')] = p; });
      var table = dialog.querySelector('[data-shto-sg-table]');
      var state = { country: countries[0] || '', unit: table ? table.getAttribute('data-base') : 'in', height: 'ft', weight: 'lbs', result: null };

      /* ---- tabs ---- */
      function showTab(name, focus) {
        if (!panes[name]) name = 'guide';
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-shto-sg-tab') === name;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && focus) t.focus();
        });
        Object.keys(panes).forEach(function (k) { panes[k].hidden = k !== name; });
        closeMenus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { showTab(t.getAttribute('data-shto-sg-tab')); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          showTab(next.getAttribute('data-shto-sg-tab'), true);
        });
      });

      /* ---- dropdowns ---- */
      var dds = [].slice.call(dialog.querySelectorAll('[data-shto-sg-dd]'));
      function opts(dd) { return [].slice.call(dd.querySelectorAll('[role="option"]')); }
      function setActive(dd, opt) {
        opts(dd).forEach(function (o) { o.classList.toggle('is-active', o === opt); });
        var menu = dd.querySelector('[data-shto-sg-menu]');
        if (opt) menu.setAttribute('aria-activedescendant', opt.id); else menu.removeAttribute('aria-activedescendant');
      }
      function openMenu(dd) {
        closeMenus(dd);
        dd.classList.add('is-open');
        dd.querySelector('[data-shto-sg-dd-btn]').setAttribute('aria-expanded', 'true');
        var menu = dd.querySelector('[data-shto-sg-menu]');
        setActive(dd, dd.querySelector('[aria-selected="true"]') || opts(dd)[0]);
        menu.focus({ preventScroll: true });
      }
      function closeMenu(dd, refocus) {
        if (!dd.classList.contains('is-open')) return;
        dd.classList.remove('is-open');
        var btn = dd.querySelector('[data-shto-sg-dd-btn]');
        btn.setAttribute('aria-expanded', 'false');
        setActive(dd, null);
        if (refocus) btn.focus({ preventScroll: true });
      }
      function closeMenus(except) { dds.forEach(function (dd) { if (dd !== except) closeMenu(dd, false); }); }
      function anyOpen() { return dds.some(function (dd) { return dd.classList.contains('is-open'); }); }
      function pick(dd, opt) {
        opts(dd).forEach(function (o) { o.setAttribute('aria-selected', o === opt ? 'true' : 'false'); });
        dd.querySelector('[data-shto-sg-dd-value]').textContent = opt.textContent;
        choose(dd.getAttribute('data-shto-sg-dd'), opt.getAttribute('data-value'));
        closeMenu(dd, true);
      }
      dds.forEach(function (dd) {
        var btn = dd.querySelector('[data-shto-sg-dd-btn]');
        var menu = dd.querySelector('[data-shto-sg-menu]');
        btn.addEventListener('click', function () { if (dd.classList.contains('is-open')) closeMenu(dd, true); else openMenu(dd); });
        btn.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); openMenu(dd); }
        });
        menu.addEventListener('keydown', function (e) {
          var list = opts(dd), cur = list.indexOf(dd.querySelector('.is-active'));
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); setActive(dd, list[Math.max(0, Math.min(list.length - 1, cur + (e.key === 'ArrowDown' ? 1 : -1)))]); }
          else if (e.key === 'Home' || e.key === 'End') { e.preventDefault(); setActive(dd, list[e.key === 'Home' ? 0 : list.length - 1]); }
          else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (list[cur]) pick(dd, list[cur]); }
          else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeMenu(dd, true); }
          else if (e.key === 'Tab') { closeMenu(dd, false); }
        });
        menu.addEventListener('click', function (e) { var o = e.target.closest('[role="option"]'); if (o) pick(dd, o); });
        menu.addEventListener('mousemove', function (e) { var o = e.target.closest('[role="option"]'); if (o && !o.classList.contains('is-active')) setActive(dd, o); });
      });
      dialog.addEventListener('pointerdown', function (e) { if (!e.target.closest('[data-shto-sg-dd]')) closeMenus(); });

      /* ---- size guide table ---- */
      var sizeCells = table ? [].slice.call(table.querySelectorAll('[data-shto-sg-size]')) : [];
      var valueCells = table ? [].slice.call(table.querySelectorAll('[data-shto-sg-value]')) : [];
      valueCells.forEach(function (c) { c.setAttribute('data-orig', c.textContent); });
      var base = state.unit;
      function convertValue(text, to) {
        if (to === base) return text;
        var suffix = cfg.cmSuffix ? ' ' + String(cfg.cmSuffix).trim() : '';
        var stripped = text.replace(/\s*(&quot;|["″”]|inches|inch|in\b|cm\b)/gi, '').trim();
        if (to === 'cm') return stripped.replace(/\d+(?:[.,]\d+)?/g, function (n) { return fmt(parseFloat(n.replace(',', '.')) * IN_CM, 1); }) + suffix;
        return stripped.replace(/\d+(?:[.,]\d+)?/g, function (n) { return String(+fmt(parseFloat(n.replace(',', '.')) / IN_CM, 2)); }) + '"';
      }
      function paintTable() {
        if (!table) return;
        valueCells.forEach(function (c) { c.textContent = convertValue(c.getAttribute('data-orig'), state.unit); });
        var country = String(state.country).toUpperCase();
        sizeCells.forEach(function (c) {
          var own = c.getAttribute('data-shto-sg-size');
          var row = conversion[norm(own)];
          c.textContent = (row && row[country]) || own;
        });
      }

      /* ---- find my size ---- */
      var form = dialog.querySelector('[data-shto-sg-form]');
      var inputs = {}; [].forEach.call(dialog.querySelectorAll('[data-shto-sg-input]'), function (i) { inputs[i.getAttribute('data-shto-sg-input')] = i; });
      var submit = dialog.querySelector('[data-shto-sg-submit]');
      var submitText = dialog.querySelector('[data-shto-sg-submit-text]');
      var result = dialog.querySelector('[data-shto-sg-result]');
      var resultText = dialog.querySelector('[data-shto-sg-result-text]');
      var resultTpl = dialog.querySelector('[data-shto-sg-result-template]');

      function heightInches() {
        if (state.height === 'cm') { var c = num(inputs.cm.value); return c ? c / IN_CM : null; }
        var f = num(inputs.ft.value), i = num(inputs.in.value) || 0;
        return f ? f * 12 + i : null;
      }
      function weightLbs() { var w = num(inputs.weight.value); return w ? (state.weight === 'kg' ? w * LB_KG : w) : null; }
      function ready() { return heightInches() != null && weightLbs() != null; }
      function paintButton() {
        if (state.result) { submit.disabled = false; submitText.textContent = submitText.getAttribute('data-reset'); return; }
        submit.disabled = !ready();
        submitText.textContent = submitText.getAttribute('data-find');
      }
      function productSizes() {
        var el = root.closest('.shto-pdp') && root.closest('.shto-pdp').querySelector('script[data-shto-product]');
        if (!el) return [];
        try {
          var p = JSON.parse(el.textContent), names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
          var idx = names.findIndex(function (n) { return /size/i.test(n); });
          if (idx < 0) return [];
          var seen = {}, out = [];
          (p.variants || []).forEach(function (v) { var s = v['option' + (idx + 1)] || (v.options || [])[idx]; if (s && !seen[s]) { seen[s] = 1; out.push(s); } });
          return out;
        } catch (e) { return []; }
      }
      function recommend() {
        var lbs = weightLbs(), inches = heightInches();
        var sizes = productSizes();
        /* Waist sizes (denim: 28, 30 ...) use the waist bands and their own tall rule (one up, never down). */
        var waist = sizes.length > 0 && sizes.every(function (x) { x = String(x).trim(); return /^\d+(\.\d+)?$/.test(x) && +x >= 20; }) && waistBands.length > 0;
        var bands = waist ? waistBands : bandsLetters;
        var tallFrom = waist ? cfg.waistTallFrom : cfg.tallFrom, shortTo = waist ? 0 : cfg.shortTo;
        /* The size guide entry's own Weight bands (e.g. a slim fit block) win, with its own height rules (empty = none). */
        if (guideBands.length) { bands = guideBands; tallFrom = cfg.guideTallFrom; shortTo = cfg.guideShortTo; }
        if (!bands.length) return null;
        var i = bands.findIndex(function (b) { return lbs <= b.max; });
        if (i < 0) i = bands.length - 1;
        if (tallFrom && inches >= tallFrom) i += 1;
        if (shortTo && inches <= shortTo) i -= 1;
        i = Math.max(0, Math.min(bands.length - 1, i));
        if (!sizes.length) return bands[i].label;
        var byKey = {}; sizes.forEach(function (s) { byKey[norm(s)] = s; });
        var best = null, bestD = Infinity;
        bands.forEach(function (b, j) {
          if (!byKey[b.key]) return;
          var d = Math.abs(j - i) - (j > i ? 0.1 : 0);
          if (d < bestD) { bestD = d; best = byKey[b.key]; }
        });
        return best || sizes[Math.min(sizes.length - 1, Math.floor(sizes.length / 2))];
      }
      function showResult(size) {
        state.result = size;
        if (size) {
          resultText.innerHTML = resultTpl.innerHTML.replace(/\[size\]/g, esc(size));
          result.hidden = false;
        } else { result.hidden = true; }
        paintButton();
      }
      function reset() {
        Object.keys(inputs).forEach(function (k) { inputs[k].value = ''; });
        showResult(null);
      }
      Object.keys(inputs).forEach(function (k) {
        inputs[k].addEventListener('input', function () {
          var clean = inputs[k].value.replace(k === 'ft' || k === 'in' ? /[^\d]/g : /[^\d.,]/g, '');
          if (clean !== inputs[k].value) inputs[k].value = clean;
          if (state.result) showResult(null); else paintButton();
        });
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (state.result) { reset(); inputs[state.height === 'cm' ? 'cm' : 'ft'].focus(); return; }
        if (!ready()) return;
        showResult(recommend());
      });
      dialog.querySelector('[data-shto-sg-add]').addEventListener('click', function () {
        if (!state.result) return;
        document.dispatchEvent(new CustomEvent('shto:select-size', { detail: { value: state.result, add: true } }));
        dialog.close();
      });

      /* A dropdown changed. */
      function choose(kind, value) {
        if (kind === 'country') { state.country = value; paintTable(); }
        else if (kind === 'unit') { state.unit = value; paintTable(); }
        else if (kind === 'height' && value !== state.height) {
          var inches = heightInches();
          state.height = value;
          inputs.ft.hidden = inputs.in.hidden = value === 'cm';
          inputs.cm.hidden = value !== 'cm';
          if (inches != null) {
            if (value === 'cm') inputs.cm.value = Math.round(inches * IN_CM);
            else { var t = Math.round(inches); inputs.ft.value = Math.floor(t / 12); inputs.in.value = t % 12; }
          }
          if (state.result) showResult(null); else paintButton();
        } else if (kind === 'weight' && value !== state.weight) {
          var w = num(inputs.weight.value);
          state.weight = value;
          inputs.weight.placeholder = dialog.querySelector('[data-shto-sg-dd="weight"] [data-value="' + value + '"]').textContent;
          if (w != null) inputs.weight.value = Math.round(value === 'kg' ? w / LB_KG : w * LB_KG);
          if (state.result) showResult(null); else paintButton();
        }
      }

      /* ---- open / close ---- */
      function open(tab) {
        showTab(tab === 'find' ? 'find' : 'guide');
        if (scroller) scroller.scrollTop = 0;
        if (!dialog.open) dialog.showModal();
        document.documentElement.classList.add('shto-lock');
      }
      dialog.querySelector('[data-shto-sg-close]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('close', function () { closeMenus(); document.documentElement.classList.remove('shto-lock'); });
      dialog.addEventListener('cancel', function (e) { if (anyOpen()) { e.preventDefault(); closeMenus(); } });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
      document.addEventListener('shto:size-guide', function (e) {
        if (!root.isConnected) return;
        open(e.detail && e.detail.tab);
      });
      document.addEventListener('shopify:block:select', function (e) { if (root.isConnected && root.contains(e.target)) open('guide'); });
      document.addEventListener('shopify:block:deselect', function (e) { if (root.isConnected && root.contains(e.target) && dialog.open) dialog.close(); });

      paintTable();
      paintButton();
    }

    function initAll(scope) { [].forEach.call((scope || document).querySelectorAll('[data-shto-size-guide]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
